export const LAUNCHPAD_DEFAULT = 1;
export const LAUNCHPAD_PREPARED_BASKET = 2;
